import image from '@/assets/images/manufacturers/develco.png';
import { option } from '@/util/container';
import { MANUFACTURERS } from '..';

export default option(MANUFACTURERS, async () => ({
  name: 'DEVELCO',
  label: 'Develco',
  image,
}));
